import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/icons/user.svg'
import _imports_1 from '../../../assets/icons/house.svg'


const _withScopeId = n => (_pushScopeId("data-v-35e91458"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "main_project_preview md:!tw-pb-16 md:!tw-box-border"
}
const _hoisted_2 = { class: "left_block" }
const _hoisted_3 = { class: "project_type__overview_card_content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "heading" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "title" }, "Project Overview")
], -1))
const _hoisted_5 = { class: "project_type__overview_card_text" }
const _hoisted_6 = { class: "project_type__overview_card_text_item" }
const _hoisted_7 = { class: "project_type__overview_list" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Address", -1))
const _hoisted_9 = { class: "project_type__overview_card_text_item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "Project Details", -1))
const _hoisted_11 = { class: "project_type__overview_list" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Project Type", -1))
const _hoisted_13 = { class: "tw-capitalize" }
const _hoisted_14 = { class: "inner__content" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Estimate")
], -1))
const _hoisted_16 = { class: "estimate_item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Start Date", -1))
const _hoisted_18 = { class: "estimate_item" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Total Phases", -1))
const _hoisted_20 = { class: "estimate_item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Total Tasks", -1))
const _hoisted_22 = { class: "estimate_item" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Duration", -1))
const _hoisted_24 = { class: "estimate_item" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Total Cost", -1))
const _hoisted_26 = { class: "right_block" }
const _hoisted_27 = { class: "top_links_main" }
const _hoisted_28 = { class: "back_results" }
const _hoisted_29 = { class: "project_info__wrapper" }
const _hoisted_30 = { class: "card_content" }
const _hoisted_31 = { class: "card_content__header" }
const _hoisted_32 = { class: "card_content__title" }
const _hoisted_33 = { id: "project_name" }
const _hoisted_34 = { class: "card_content__title_info" }
const _hoisted_35 = {
  class: "raised",
  "data-comment-element": "true",
  id: "project_review_item_icon_commerical"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "pointer_events_none",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pointer_events_none" }, "Commercial", -1))
const _hoisted_38 = { class: "card_content__footer" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Project Notes", -1))
const _hoisted_40 = ["innerHTML"]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h6", null, "Project Title")
], -1))
const _hoisted_42 = { class: "description" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Project Notes", -1))
const _hoisted_44 = { class: "custom_editor" }
const _hoisted_45 = { class: "edit__buttons" }
const _hoisted_46 = { class: "specialism__wrapper" }
const _hoisted_47 = { class: "header" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Service")
], -1))
const _hoisted_49 = { class: "specialism__wrapper__content" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = {
  key: 1,
  class: "specialism-card-list"
}
const _hoisted_52 = { class: "specialism-card-list__item-author" }
const _hoisted_53 = { class: "speicalism__icon" }
const _hoisted_54 = ["src"]
const _hoisted_55 = ["src"]
const _hoisted_56 = { class: "specialism-card-list__item-author-content" }
const _hoisted_57 = { class: "category_icon" }
const _hoisted_58 = ["src"]
const _hoisted_59 = { class: "category_text" }
const _hoisted_60 = {
  key: 0,
  class: "edit-mode-button"
}
const _hoisted_61 = { class: "edit__buttons" }
const _hoisted_62 = { class: "properties_wrapper" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "Properties")
  ])
], -1))
const _hoisted_64 = { class: "properties_wrapper__content" }
const _hoisted_65 = { class: "properties_wrapper__left no-scrollbar" }
const _hoisted_66 = { class: "properties_wrapper__info" }
const _hoisted_67 = { class: "properties_wrapper__info__left" }
const _hoisted_68 = { class: "location" }
const _hoisted_69 = { class: "prop_name" }
const _hoisted_70 = ["src"]
const _hoisted_71 = { class: "property__info" }
const _hoisted_72 = { class: "property__info__item" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "|", -1))
const _hoisted_74 = { class: "property__info__item" }
const _hoisted_75 = { class: "pointer_events_none" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "|", -1))
const _hoisted_77 = { class: "property__info__item" }
const _hoisted_78 = { class: "pointer_events_none" }
const _hoisted_79 = { class: "property_type" }
const _hoisted_80 = { class: "properties_wrapper__info__right" }
const _hoisted_81 = { class: "property_image" }
const _hoisted_82 = ["src"]
const _hoisted_83 = { class: "properties_wrapper__right" }
const _hoisted_84 = {
  key: 0,
  class: "map__wrapper",
  id: "map_properties"
}
const _hoisted_85 = { class: "documents_attachment" }
const _hoisted_86 = { class: "title" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Documents / Attachments", -1))
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_89 = {
  key: 0,
  class: "group__cards"
}
const _hoisted_90 = { class: "group__card__text sdasdasdas" }
const _hoisted_91 = { class: "accordion_inner_title" }
const _hoisted_92 = { class: "doc_main" }
const _hoisted_93 = { class: "property__img__name" }
const _hoisted_94 = ["onClick"]
const _hoisted_95 = { class: "property__images" }
const _hoisted_96 = ["src", "onClick"]
const _hoisted_97 = {
  key: 0,
  class: "edit-mode-button"
}
const _hoisted_98 = { class: "edit__buttons" }

import { ref, reactive, getCurrentInstance, onMounted, computed } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { quillEditor } from "vue3-quill";
import moment from "moment";
import SpecialismMultiSelectModel from "@/modules/project/modal/SpecialismMultiSelectModel.vue";
import CommonLoader from "@/core/components/CommonLoader.vue";
import EmergencyChip from "@/core/uni-components/Chips/EmergencyChip.vue";
import StandardChip from "@/core/uni-components/Chips/StandardChip.vue";
import RoutineChip from "@/core/uni-components/Chips/RoutineChip.vue";
import { parseJSON } from "@/core/utils/common";
import {
  HistoricProjectStatusEnum,
  ProjectTypesEnum,
} from "@/core/enums/ProjectsEnum";
import { PROJECT, PROJECT_STORE } from "@/store/modules/project";
import { TRADE_ESTIMATE_STORE } from "@/store/modules/trade-estimate";
import AddressMapComponent from "@/core/components/AddressMapComponent.vue";
import CurrencyFilter from "@/filters/currency.filter";
import UploadProjectAttachmentsModal from "../modal/UploadProjectAttachmentsModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'HistoricProjectReviewComponent',
  props: {
  projectRefId: {
    type: String,
  },
},
  setup(__props) {

const internalInstance = getCurrentInstance();
const props = __props;
const loading = ref(true);
const isLoadingProjectData = ref(false);
const ProjectData = ref() as any;
const estimateDetails = ref() as any;
const availableCategoryList = ref();

// Project Notes
const isEditProjectNoteSection = ref(false);
const projectTitle = ref("");
const isLoadingProjectNotes = ref(false);
const state = reactive({
  content: "",
  _content: "",
  editorOption: {
    placeholder: "Description here",
    modules: {},
  },
  disabled: false,
});

// Specialisms
const isEditSpecialismSection = ref(false);
const isShowSpecialismModal = ref(false);
const isLoadingForSaveSpecialism = ref(false);

// Properties
const addresses = ref([]) as any;

// Documents
const isDocumentsLoading = ref(false) as any;
const projectAttachments = ref() as any;
const cloneAttachmentDataList = ref() as any;
const panel = ref([]) as any;
const isEditAttachmentsSection = ref({
  flag: false,
  index: -1,
});
const attachmentsData = ref() as any;
const isCarouselDialog = ref(false);
const carouselImageList = ref([]) as any;
const currentIndex = ref(0);
const isShowProjectAttachmentUploadModal = ref(false);

const store = useStore();

const isProjectPending = computed(
  () =>
    ProjectData.value?.projectHistoricalStatus ==
    HistoricProjectStatusEnum.PENDING
);

const formatDate = (startDate: string) => {
  if (!startDate) {
    return "N/A";
  }
  const date = new Date(startDate);
  const options = { day: "2-digit", month: "long", year: "numeric" } as any;
  return date.toLocaleDateString("en-GB", options);
};

const formatDuration = (sDate: any, eDate: any) => {
  if (!sDate || !eDate) {
    return 0;
  }

  const startDate = moment(sDate) as any;
  const endDate = moment(eDate) as any;

  const totalDays = endDate.diff(startDate, "days");

  if (totalDays % 7 === 0) {
    const totalWeeks = totalDays / 7;
    return `${totalWeeks} week${totalWeeks > 1 ? "s" : ""}`;
  }

  return `${totalDays} day${totalDays > 1 ? "s" : ""}`;
};

const onClickSaveButtonAttachments = async (attachmentsPayload: any) => {
  try {
    if (
      attachmentsPayload?.updatePayload?.length ||
      attachmentsData.value.length != projectAttachments.value.length
    ) {
      isDocumentsLoading.value = true;
      const presentAttachmentsIds = attachmentsData.value.map(
        (o: any) => o.uploadedImages?.id
      );
      let removedAttachment = projectAttachments.value.filter(
        (o: any) => !presentAttachmentsIds.includes(o.uploadedImages.id)
      );
      removedAttachment = removedAttachment.map((o: any) => ({
        id: o.uploadedImages?.id,
        propertyIds: [
          {
            propertyId: ProjectData.value?.id,
            isDeleted: true,
          },
        ],
        isDeleted: true,
      }));

      const updateAttachmentDataRes = await store.dispatch(
        `${PROJECT_STORE}/updateHistoricalProject`,
        {
          projectId: ProjectData.value?.id,
          data: {
            attachments: [
              ...(attachmentsPayload?.updatePayload || []),
              ...removedAttachment,
            ],
          },
        }
      );

      if (attachmentsPayload?.updatePayload?.length) {
        attachmentsPayload?.attachmentData.forEach((attachment: any) => {
          if (attachment.uploadedImages.imageData) {
            const updatedAttachment =
              updateAttachmentDataRes.projectAttachments.find(
                (projectAttachment: any) =>
                  projectAttachment.originalName ===
                  attachment.uploadedImages.name
              );

            if (updatedAttachment?.id) {
              attachment.uploadedImages = {
                ...(attachment?.uploadedImages || {}),
                imageData: null,
                id: updatedAttachment.id,
                attachment: updatedAttachment.attachment,
              };
            }
          }
        });
        attachmentsData.value = attachmentsPayload?.attachmentData;
      }
      projectAttachments.value = JSON.parse(
        JSON.stringify(attachmentsData.value)
      );
      cloneAttachmentDataList.value = getFilterCategory(
        projectAttachments.value
      );
      displayToast("Update successfully.", "success");
      // await setProjectData();
    }
    isEditAttachmentsSection.value.flag = false;
  } catch (error) {
    console.log("attechment update error", error);
  } finally {
    isDocumentsLoading.value = false;
  }
};

const toggleEditAttachmentsSection = () => {
  isEditAttachmentsSection.value.flag = !isEditAttachmentsSection.value.flag;
};

const onCancelAttachments = async () => {
  toggleEditAttachmentsSection();
  attachmentsData.value = JSON.parse(JSON.stringify(projectAttachments.value));
  cloneAttachmentDataList.value = getFilterCategory(projectAttachments.value);
};

const onClickToggleAttachmentModal = (payload: any) => {
  isShowProjectAttachmentUploadModal.value =
    !isShowProjectAttachmentUploadModal.value;
};

const openCarousel = (idx = 0) => {
  isCarouselDialog.value = true;
  const carouselImages = [] as any;
  cloneAttachmentDataList.value.map((data: any) => {
    data.attachments.map((attachment: any) => {
      carouselImages.push({ url: attachment?.uploadedImages?.url });
    });
    carouselImageList.value = carouselImages;
  });
  currentIndex.value = idx;
};

const onClickRemoveAttachment = (imgId: any) => {
  cloneAttachmentDataList.value = cloneAttachmentDataList.value.map(
    (category: any) => {
      return {
        userCategoryName: category.userCategoryName,
        attachments: category.attachments.filter(
          (attachment: any) => attachment.uploadedImages.id !== imgId
        ),
      };
    }
  );

  attachmentsData.value = attachmentsData.value.filter(
    (attachment: any) => attachment.uploadedImages.id !== imgId
  );
};

const isShowGroupCard = (index: any) => {
  return panel.value.includes(index);
};

const updateAttachmentsSection = (index: any) => {
  isEditAttachmentsSection.value.flag = true;
  isEditAttachmentsSection.value.index = index;
  panel.value.push(index);
};

const getFilterCategory = (attachments: any) => {
  const grouped =
    attachments?.reduce((acc: any, item: any) => {
      const { userCategoryName, uploadedImages, propertyId } = item;
      if (!acc[userCategoryName]) {
        acc[userCategoryName] = [];
      }
      acc[userCategoryName].push({ uploadedImages, propertyId });
      return acc;
    }, {}) || {};
  return Object.keys(grouped).map((key) => ({
    userCategoryName: key,
    attachments: grouped[key],
  }));
};

const changeCategoryId = (categories: any) => {
  if (categories.length > 0) {
    const filterData = projectAttachments.value.filter((attachement: any) =>
      categories.includes(attachement.userCategoryName)
    );

    cloneAttachmentDataList.value = getFilterCategory(filterData);
  } else {
    cloneAttachmentDataList.value = getFilterCategory(projectAttachments.value);
  }
};

const updateSpecialismSection = () => {
  isEditSpecialismSection.value = true;
};

const onClickDeleteCategoryButton = (subCategoryId: number) => {
  ProjectData.value.subCategories = ProjectData.value.subCategories.filter(
    (subCategory: any) => {
      return subCategory.id !== subCategoryId;
    }
  );
};

const specialismCategoryClass = (val: string) => {
  if (val.toLowerCase() === "krystal") {
    return "krystal";
  }
  if (val.toLowerCase() === "property") {
    return "property";
  }
  if (val.toLowerCase() === "trade") {
    return "trade";
  }
};

const onClickAddMoreSpecialism = () => {
  isShowSpecialismModal.value = true;
};

const onClickCloseTab = () => {
  isShowSpecialismModal.value = false;
  setProjectData();
};

const onClickSaveButtonClick = async (selectedCategory: any) => {
  try {
    isLoadingForSaveSpecialism.value = true;
    const projectSubCategories = ProjectData.value?.subCategories.map(
      (subCategory: any) => {
        return subCategory.id;
      }
    );

    const removedSubCategories = projectSubCategories.filter(
      (subCategoryId: number) => {
        return !selectedCategory.includes(subCategoryId);
      }
    );

    if (removedSubCategories.length) {
      ProjectData.value.subCategories = ProjectData.value.subCategories.filter(
        (subCategory: any) => {
          return !removedSubCategories.includes(subCategory.id);
        }
      );
    }

    const newAddedSubCategoriesIds = selectedCategory.filter(
      (subCategoryId: number) => {
        return !projectSubCategories.includes(subCategoryId);
      }
    );

    if (newAddedSubCategoriesIds.length) {
      const newAddedSubCategoriesData = await store.dispatch(
        `${PROJECT_STORE}/getNewAddedSubCategoryForProject`,
        {
          subCategoriesIds: newAddedSubCategoriesIds,
        }
      );

      newAddedSubCategoriesData.forEach((subCategory: any) => {
        ProjectData.value?.subCategories.push(subCategory);
      });
    }
  } catch (error) {
    console.log(error);
  } finally {
    isLoadingForSaveSpecialism.value = false;
    isShowSpecialismModal.value = false;
  }
};

const onClickCancelSpecialismButton = async () => {
  isEditSpecialismSection.value = false;
  await setProjectData();
};

const onClickSaveSpecialismButton = async () => {
  let selectedCategoryFinal = ProjectData.value?.subCategories.map(
    (subCategory: any) => {
      return subCategory.id;
    }
  );

  await store.dispatch(`${PROJECT_STORE}/updateSubSpecialismCategory`, {
    projectId: ProjectData.value?.id,
    data: {
      categoryData: selectedCategoryFinal,
    },
  });

  onClickCancelSpecialismButton();
};

const updateProjectNameNote = (ProjectDetails: any) => {
  isEditProjectNoteSection.value = true;
  projectTitle.value = ProjectDetails?.name;
  state.content = ProjectDetails?.description;
};

const displayToast = (message: string, type: string) => {
  if (
    internalInstance &&
    internalInstance.appContext.config.globalProperties.$notify
  ) {
    internalInstance.appContext.config.globalProperties.$notify[type]({
      message,
    });
  }
};

const onCancelProjectNotes = () => {
  isEditProjectNoteSection.value = false;
};

const onClickSaveProjectNotes = async () => {
  try {
    isLoadingProjectNotes.value = true;
    await store.dispatch(`${PROJECT_STORE}/updateProject`, {
      projectId: ProjectData.value?.id,
      data: {
        description: state.content,
        name: projectTitle.value,
      },
    });
    await setProjectData();
    displayToast("Update successfully.", "success");
  } catch (error) {
    console.log(error);
  } finally {
    isEditProjectNoteSection.value = false;
    isLoadingProjectNotes.value = false;
  }
};

const setProjectData = async () => {
  try {
    isLoadingProjectData.value = true;
    const projectDataResponse = await store.dispatch(
      `${PROJECT_STORE}/getProjectData`,
      {
        projectRefId: props.projectRefId,
      }
    );

    availableCategoryList.value = await store.dispatch(
      `${PROJECT_STORE}/getProjectCategoryList`,
      projectDataResponse.id
    );
    ProjectData.value = projectDataResponse;

    // This just sets the project details
    store.dispatch(`${PROJECT}/projectDetails`, {
      inviteMembers: ProjectData.value?.invitedMembersAndRoles,
    });

    const address = parseJSON(
      ProjectData.value?.projectProperties?.[0]?.property?.addressData
    );

    if (address) {
      address.latlang = [53.5809811, -0.6393335];
      addresses.value.push(address);
    }

    projectAttachments.value = projectDataResponse?.projectAttachments?.length
      ? Object.values(
          projectDataResponse?.projectAttachments[0]?.categories
        ).flatMap((attachments: any) => {
          return attachments.map((attachment: any) => ({
            propertyId: projectDataResponse?.projectAttachments[0]?.propertyId,
            userCategoryName: attachment.name,
            uploadedImages: {
              id: attachment.id,
              name: attachment.originalName,
              attachment: attachment.attachment,
              url: attachment.attachmentUrl,
            },
          }));
        })
      : [];
    cloneAttachmentDataList.value = getFilterCategory(projectAttachments.value);
    attachmentsData.value = JSON.parse(
      JSON.stringify(projectAttachments.value)
    );
  } catch (error) {
    console.log();
  } finally {
    isLoadingProjectData.value = false;
  }
};

const getProjectData = async () => {
  try {
    loading.value = true;
    await setProjectData();
  } catch (error) {
    console.log("error:", error);
  } finally {
    loading.value = false;
  }
};

onMounted(async () => {
  await getProjectData();
  estimateDetails.value = await store.dispatch(
    `${TRADE_ESTIMATE_STORE}/setTradeEstimateDetails`,
    {
      projectEstimateId: ProjectData.value.projectEstimateId,
    }
  );
});

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_carousel_item = _resolveComponent("v-carousel-item")!
  const _component_v_carousel = _resolveComponent("v-carousel")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_v_card, { class: "project_type__overview_card" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _hoisted_8,
                        _createElementVNode("p", null, _toDisplayString(ProjectData.value?.projectProperties[0]?.property?.address), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("div", _hoisted_11, [
                        _hoisted_12,
                        _createElementVNode("p", _hoisted_13, _toDisplayString(ProjectData.value?.type), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("p", null, _toDisplayString(formatDate(ProjectData.value?.startDate)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("p", null, _toDisplayString(estimateDetails.value?.estimationPhase?.length || 0), 1)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("p", null, _toDisplayString(estimateDetails.value?.estimationPhase?.reduce(
                  (oldCount, phase) => oldCount + phase.taskCount,
                  0
                ) || 0), 1)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _createElementVNode("p", null, _toDisplayString(formatDuration(ProjectData.value?.startDate, ProjectData.value?.endDate)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("p", null, _toDisplayString(_unref(CurrencyFilter).formatToCurrency(
                  estimateDetails.value?.totalEstimateCost
                )), 1)
                  ])
                ]),
                _createVNode(_component_v_btn, {
                  class: "button button-orange",
                  width: "100%",
                  "max-width": "100%",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('view-estimate')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("VIEW ESTIMATE")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createVNode(_component_v_btn, {
                  "prepend-icon": "mdi-chevron-left",
                  variant: "plain",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('back')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Back")
                  ]),
                  _: 1
                })
              ]),
              (ProjectData.value?.type === _unref(ProjectTypesEnum).EMERGENCY)
                ? (_openBlock(), _createBlock(EmergencyChip, { key: 0 }))
                : (ProjectData.value?.type === _unref(ProjectTypesEnum).STANDARD)
                  ? (_openBlock(), _createBlock(StandardChip, { key: 1 }))
                  : (ProjectData.value?.type === _unref(ProjectTypesEnum).ROUTINE)
                    ? (_openBlock(), _createBlock(RoutineChip, { key: 2 }))
                    : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_29, [
              (!isEditProjectNoteSection.value)
                ? (_openBlock(), _createBlock(_component_v_card, {
                    key: 0,
                    class: "project_info"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("h5", _hoisted_33, _toDisplayString(ProjectData.value?.name), 1),
                            _createElementVNode("div", _hoisted_34, [
                              _createElementVNode("div", _hoisted_35, [
                                _createVNode(_component_v_icon, { class: "pointer_events_none" }, {
                                  default: _withCtx(() => [
                                    _hoisted_36
                                  ]),
                                  _: 1
                                }),
                                _hoisted_37
                              ])
                            ])
                          ]),
                          (isProjectPending.value)
                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                key: 0,
                                class: "custom_edit",
                                icon: "mdi-pencil",
                                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (updateProjectNameNote(ProjectData.value)), ["stop"]))
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_38, [
                          _hoisted_39,
                          _createElementVNode("p", {
                            innerHTML: ProjectData.value?.description,
                            id: "project_html_description"
                          }, null, 8, _hoisted_40)
                        ])
                      ])
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_v_card, {
                    key: 1,
                    class: "edit_project_info"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_41,
                      _createVNode(_component_v_text_field, {
                        density: "compact",
                        placeholder: "Enter Title",
                        variant: "outlined",
                        class: "property_input",
                        modelValue: projectTitle.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((projectTitle).value = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_42, [
                        _hoisted_43,
                        _createElementVNode("div", _hoisted_44, [
                          _createVNode(_unref(quillEditor), {
                            value: state.content,
                            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((state.content) = $event)),
                            options: state.editorOption,
                            disabled: state.disabled,
                            class: "editor_ql"
                          }, null, 8, ["value", "options", "disabled"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_45, [
                        _createVNode(_component_v_btn, {
                          class: "button button-white",
                          onClick: onCancelProjectNotes,
                          variant: "outlined"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" cancel ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, {
                          class: "button button-orange",
                          onClick: onClickSaveProjectNotes,
                          loading: isLoadingProjectNotes.value,
                          "prepend-icon": "mdi-content-save"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" save ")
                          ]),
                          _: 1
                        }, 8, ["loading"])
                      ])
                    ]),
                    _: 1
                  }))
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _hoisted_48,
                (!isEditSpecialismSection.value && isProjectPending.value)
                  ? (_openBlock(), _createBlock(_component_v_icon, {
                      key: 0,
                      class: "custom_edit",
                      icon: "mdi-pencil",
                      onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (updateSpecialismSection()), ["stop"]))
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_49, [
                (!ProjectData.value?.subCategories?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, "No Service"))
                  : (_openBlock(), _createElementBlock("div", _hoisted_51, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ProjectData.value?.subCategories, (subCategory) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "specialism-card-list__item",
                          key: subCategory.id
                        }, [
                          (isEditSpecialismSection.value)
                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                key: 0,
                                variant: "text",
                                "aria-label": "Delete",
                                class: "specialism-card-list__item-delete",
                                "prepend-icon": "mdi-delete",
                                onClick: ($event: any) => (onClickDeleteCategoryButton(subCategory?.id))
                              }, null, 8, ["onClick"]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_52, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["specialism-card-list__item-author-header", specialismCategoryClass(subCategory?.generatedBy)])
                            }, [
                              _createElementVNode("div", _hoisted_53, [
                                (
                        specialismCategoryClass(subCategory?.generatedBy) ===
                        'krystal'
                      )
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: require('@/assets/icons/krystal.svg'),
                                      alt: "krystalimg"
                                    }, null, 8, _hoisted_54))
                                  : _createCommentVNode("", true),
                                (
                        specialismCategoryClass(subCategory?.generatedBy) ===
                        'property'
                      )
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 1,
                                      src: require('@/assets/icons/house.svg'),
                                      alt: "houseimage"
                                    }, null, 8, _hoisted_55))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("h6", null, _toDisplayString(subCategory?.generatedBy), 1),
                              _createVNode(_component_v_icon, { icon: "mdi-information-variant-circle-outline" })
                            ], 2),
                            _createElementVNode("div", _hoisted_56, [
                              _createElementVNode("div", _hoisted_57, [
                                _createElementVNode("img", {
                                  src: 
                        require('@/assets/category-icons/' +
                          subCategory?.category?.iconName +
                          '.svg')
                      ,
                                  alt: "Image"
                                }, null, 8, _hoisted_58)
                              ]),
                              _createElementVNode("div", _hoisted_59, [
                                _createElementVNode("h5", null, _toDisplayString(subCategory?.label), 1),
                                _createElementVNode("p", null, _toDisplayString(subCategory?.category?.poLabel), 1)
                              ])
                            ])
                          ])
                        ]))
                      }), 128))
                    ]))
              ]),
              (isEditSpecialismSection.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                    _createVNode(_component_v_btn, {
                      class: "button button-purple-border",
                      variant: "text",
                      onClick: onClickAddMoreSpecialism
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Add more Specialism ")
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_61, [
                      _createVNode(_component_v_btn, {
                        class: "button button-white",
                        onClick: onClickCancelSpecialismButton,
                        variant: "outlined"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" cancel ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_btn, {
                        class: "button button-orange",
                        loading: isLoadingProjectData.value,
                        onClick: onClickSaveSpecialismButton
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" save ")
                        ]),
                        _: 1
                      }, 8, ["loading"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_62, [
              _hoisted_63,
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", _hoisted_65, [
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("div", _hoisted_67, [
                      _createElementVNode("div", _hoisted_68, [
                        _createVNode(_component_v_icon, {
                          icon: "mdi mdi-map-marker",
                          class: "pointer_events_none"
                        }),
                        _createTextVNode(" " + _toDisplayString(ProjectData.value?.projectProperties[0]?.property?.postcode), 1)
                      ]),
                      _createElementVNode("div", _hoisted_69, [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: require('@/assets/icons/house.svg'),
                              alt: ""
                            }, null, 8, _hoisted_70)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("h6", null, _toDisplayString(ProjectData.value?.projectProperties[0]?.property?.nickName), 1)
                      ]),
                      _createElementVNode("div", _hoisted_71, [
                        _createElementVNode("div", _hoisted_72, _toDisplayString(ProjectData.value?.projectProperties[0]?.property
                        ?.propertyType || "NA"), 1),
                        _hoisted_73,
                        _createElementVNode("div", _hoisted_74, [
                          _createElementVNode("span", _hoisted_75, _toDisplayString(ProjectData.value?.projectProperties[0]?.property?.beds ||
                        "NA"), 1),
                          _createTextVNode(" bedroom ")
                        ]),
                        _hoisted_76,
                        _createElementVNode("div", _hoisted_77, [
                          _createElementVNode("span", _hoisted_78, _toDisplayString(ProjectData.value?.projectProperties[0]?.property
                        ?.propertySize || "NA"), 1),
                          _createTextVNode(" sqm ")
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_79, [
                        _createVNode(_component_v_icon, {
                          icon: "mdi mdi-account-circle",
                          class: "pointer_events_none"
                        }),
                        _createTextVNode("Commercial ")
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_80, [
                      _createElementVNode("div", _hoisted_81, [
                        _createElementVNode("img", {
                          src: require('@/assets/images/property-sample-image.jpg'),
                          alt: ""
                        }, null, 8, _hoisted_82)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_83, [
                  (addresses.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                        _createVNode(AddressMapComponent, {
                          class: "pointer_events_none",
                          latlng: [53.5809811, -0.6393335],
                          addresses: addresses.value
                        }, null, 8, ["addresses"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_85, [
              _createElementVNode("div", _hoisted_86, [
                _hoisted_87,
                _createVNode(_component_v_select, {
                  label: "All categories",
                  items: getFilterCategory(projectAttachments.value),
                  "item-title": "userCategoryName",
                  "item-value": "userCategoryName",
                  multiple: "",
                  variant: "outlined",
                  density: "compact",
                  class: "select_prop_dropdown",
                  "onUpdate:modelValue": changeCategoryId,
                  "menu-props": { contentClass: 'custom__text__selector' }
                }, null, 8, ["items"])
              ]),
              (!cloneAttachmentDataList.value?.length && isProjectPending.value)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    class: "button button-purple-border",
                    onClick: onClickToggleAttachmentModal
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Upload Attachment ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_expansion_panels, {
                modelValue: panel.value,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((panel).value = $event)),
                multiple: "",
                class: "accordion__wrapper"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cloneAttachmentDataList.value, (attachmentCategory, index) => {
                    return (_openBlock(), _createBlock(_component_v_expansion_panel, { key: index }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_expansion_panel_title, null, {
                          actions: _withCtx(({ expanded }) => [
                            (
                    expanded &&
                    !isEditAttachmentsSection.value.flag &&
                    isProjectPending.value
                  )
                              ? (_openBlock(), _createBlock(_component_v_icon, {
                                  key: 0,
                                  class: "custom_edit",
                                  icon: "mdi-pencil",
                                  onClick: ($event: any) => (updateAttachmentsSection(index))
                                }, null, 8, ["onClick"]))
                              : (_openBlock(), _createBlock(_component_v_icon, {
                                  key: 1,
                                  icon: "mdi-chevron-down",
                                  class: "bottom__chevron"
                                }))
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { class: "house__icon" }, {
                              default: _withCtx(() => [
                                _hoisted_88
                              ]),
                              _: 1
                            }),
                            _createElementVNode("h6", null, _toDisplayString(attachmentCategory?.userCategoryName), 1)
                          ]),
                          _: 2
                        }, 1024),
                        (isShowGroupCard(index))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                              _createElementVNode("div", _hoisted_90, [
                                _createVNode(_component_v_expansion_panel_text, null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_91, [
                                      _createElementVNode("div", _hoisted_92, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attachmentCategory.attachments, (attachment) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            class: "doc_main__list",
                                            key: attachment.id
                                          }, [
                                            _createElementVNode("div", _hoisted_93, [
                                              _createVNode(_component_v_icon, { icon: "mdi mdi-image-outline" }),
                                              _createElementVNode("span", null, _toDisplayString(attachment?.uploadedImages?.name), 1)
                                            ]),
                                            (
                            isEditAttachmentsSection.value.flag &&
                            isEditAttachmentsSection.value.index === index
                          )
                                              ? (_openBlock(), _createElementBlock("div", {
                                                  key: 0,
                                                  onClick: ($event: any) => (
                            onClickRemoveAttachment(
                              attachment?.uploadedImages?.id
                            )
                          )
                                                }, [
                                                  _createVNode(_component_v_icon, {
                                                    icon: "mdi-close",
                                                    class: "pointer_events_none"
                                                  })
                                                ], 8, _hoisted_94))
                                              : _createCommentVNode("", true)
                                          ]))
                                        }), 128))
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_95, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attachmentCategory.attachments, (attachment) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: attachment.id,
                                          class: "property__item__images"
                                        }, [
                                          _createElementVNode("img", {
                                            src: attachment?.uploadedImages?.url,
                                            onClick: ($event: any) => (openCarousel(index))
                                          }, null, 8, _hoisted_96)
                                        ]))
                                      }), 128))
                                    ]),
                                    (
                      isEditAttachmentsSection.value.flag &&
                      isEditAttachmentsSection.value.index == index
                    )
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                                          _createVNode(_component_v_btn, {
                                            class: "button button-purple-border",
                                            onClick: onClickToggleAttachmentModal
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" Upload More ")
                                            ]),
                                            _: 1
                                          }),
                                          _createElementVNode("div", _hoisted_98, [
                                            _createVNode(_component_v_btn, {
                                              class: "button button-white",
                                              variant: "outlined",
                                              onClick: onCancelAttachments
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" cancel ")
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_btn, {
                                              class: "button button-orange",
                                              size: "large",
                                              block: "",
                                              onClick: _cache[6] || (_cache[6] = ($event: any) => (onClickSaveButtonAttachments(null)))
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" save ")
                                              ]),
                                              _: 1
                                            })
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createVNode(CommonLoader, { loading: isDocumentsLoading.value }, null, 8, ["loading"])
          ]),
          (isShowSpecialismModal.value)
            ? (_openBlock(), _createBlock(SpecialismMultiSelectModel, {
                key: 0,
                isHistorical: false,
                projectId: ProjectData.value.id,
                selectedSpecialism: ProjectData.value?.subCategories,
                isLoading: isLoadingForSaveSpecialism.value,
                onOnClickCloseTab: onClickCloseTab,
                onOnClickSaveButtonClick: onClickSaveButtonClick
              }, null, 8, ["projectId", "selectedSpecialism", "isLoading"]))
            : _createCommentVNode("", true),
          (isShowProjectAttachmentUploadModal.value)
            ? (_openBlock(), _createBlock(UploadProjectAttachmentsModal, {
                key: 1,
                projectAttachments: attachmentsData.value,
                projectData: ProjectData.value,
                onOnSave: onClickSaveButtonAttachments,
                onOnClose: onClickToggleAttachmentModal
              }, null, 8, ["projectAttachments", "projectData"]))
            : _createCommentVNode("", true),
          _createVNode(_component_v_dialog, {
            modelValue: isCarouselDialog.value,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((isCarouselDialog).value = $event)),
            height: "auto",
            "max-width": "600",
            class: "project__carousal__modal",
            "show-arrows": false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, null, {
                actions: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    icon: "mdi-close",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (isCarouselDialog.value = false)),
                    class: "d-flex"
                  }),
                  _createVNode(_component_v_carousel, {
                    "hide-delimiter-background": "",
                    "show-arrows": "hover",
                    modelValue: currentIndex.value,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((currentIndex).value = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(carouselImageList.value, (attachment) => {
                        return (_openBlock(), _createBlock(_component_v_carousel_item, {
                          key: attachment.id
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_img, {
                              cover: "",
                              src: attachment?.url,
                              height: "100%",
                              width: "100%"
                            }, null, 8, ["src"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(CommonLoader, { loading: loading.value }, null, 8, ["loading"])
  ], 64))
}
}

})